import { render } from "./InstallWizardSiteConfig.vue?vue&type=template&id=3a707fbf"
import script from "./InstallWizardSiteConfig.vue?vue&type=script&lang=js"
export * from "./InstallWizardSiteConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__